import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  disabled = false;

  constructor(
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.getInfoTotem();
  }

  async getInfoTotem(): Promise<void> {
    const response = await this.authService.parametrosTotem();

    if (response) {
      localStorage.setItem('cbNombreTotem', response['nombreTotem']);
      localStorage.setItem('cbSucursal', response['sucursal']);
    }
  }

  async getAuthorization(event: any) {
    event.preventDefault();
  }

}
